import React, { useState } from 'react';
import './SalesMovement.scss';
import { FiSearch, FiCalendar, FiFilter, FiDownload, FiEdit2, FiLink2, FiTrash2 } from 'react-icons/fi';
import { FaArrowUp } from "react-icons/fa";
import { FaRegCommentDots } from "react-icons/fa6";
import { Link } from 'react-router-dom';
const SalesMovement = () => {
  const [selectedTimeframe, setSelectedTimeframe] = useState('all');
  const [openedDropdown, setOpenedDropdown] = useState(null);
  const timeframes = [
    { id: 'all', label: 'All times' },
    { id: '24h', label: '24 Hour' },
    { id: '7d', label: '7 Days' },
    { id: '30d', label: '30 Days' },
    { id: '12m', label: '12 Months' },
  ];

  const products = [
    {
      id: 'YM',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Actives',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'SM',
      name: 'Ads Services',
      subtext: 'Ads Prod',
      status: 'Actives',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'TH',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Actives',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'FM',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Actives',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'LM',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Stable',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'XM1',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Inactives',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    },
    {
      id: 'XM2',
      name: 'Ads Services',
      subtext: 'Ads Product',
      status: 'Actives',
      price: '$14.88',
      sales: '1,368',
      salesChange: '37.8%',
      views: '1,368',
    }
  ];

  const handleProductAction = (productId, action) => {
    console.log(`${action} for product ${productId}`);
  };

  return (
    <div className="sales-movement p-3">
  <div className="headerr">
  <div className="stock-filters">
    <button className="stock-filter actives">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>

  <div className="search-wrapperr">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
      <button className="stock-btn blue">Filters</button>
      <button className="stock-btn">Export</button>
    </div>
  </div>
</div>



      <div className="products-table">
        <table>
          <thead>
            <tr>
              <th><input type="checkbox" /></th>
              <th>Product</th>
              <th>Status</th>
              <th>Price</th>
              <th>Sales</th>
              <th>Views</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product) => (
              <tr key={product.id}>
                <td><input type="checkbox" /></td>
      <td>
  <div className="product-cell">
    <div className={`product-icon ${product.id.toLowerCase()}`}>
      {product.id}
    </div>
    <div className="product-info">
      <div className="product-name">{product.name}</div>
      <div className="product-subtext">{product.subtext}</div>
    </div>
  </div>
</td>

                <td>
                  <span className={`status ${product.status.toLowerCase()}`}>
                    {product.status}
                  </span>

                       <div className="action-buttons">
                    <button onClick={() => handleProductAction(product.id, 'edit')} title="Edit title & description">
                     <FaRegCommentDots/>

                    </button>
                    <button onClick={() => handleProductAction(product.id, 'link')} title="Get shareable link">
                      <FiEdit2 />

                    </button>
                     <div className="dots-wrapper">
                    <button
                      onClick={() => setOpenedDropdown(openedDropdown === product.id ? null : product.id)}
                      title="Options"
                      className="dots-menu-btn"
                    >
                      ...
                    </button>
                    {openedDropdown === product.id && (
                      <div className="dropdown-menu">
                        <button onClick={() => handleProductAction(product.id, 'edit')}>
                          <FiEdit2 /> Edit
                        </button>
                        <button onClick={() => handleProductAction(product.id, 'link')}>
                          <FiLink2 /> Share link
                        </button>
                        <button onClick={() => handleProductAction(product.id, 'delete')} className="delete">
                          <FiTrash2 /> Delete
                        </button>
                      </div>
                    )}
                  </div>
                
                  </div>
                </td>
                <td > <span  style={{
                  backgroundColor:"#eaf4ff",
                  padding:"2px",
                  paddingLeft:"5px",
                  paddingRight:"5px",
                  borderRadius:"7px",
                   fontWeight:"bold",
                }}>
                  {product.price}
                  </span></td>
                <td>
                  <div className="sales-info">
                    <span  style={{
                  backgroundColor:"#dedede",
                  fontWeight:"bold",
                  padding:"2px",
                  paddingLeft:"5px",
                  paddingRight:"5px",
                  borderRadius:"7px"
                }}>{product.sales}</span>
                    <span className="sales-change fw-bold">
                      <FaArrowUp />
                    {product.salesChange}</span>
                  </div>
                </td>
                <td >
                  <span style={{
                  backgroundColor:"#dedede",
                  fontWeight:"bold",
                  padding:"2px",
                  paddingLeft:"5px",
                  paddingRight:"5px",
                  borderRadius:"7px"
                }}>
                  {product.views}  </span></td>
                <td>
                  <div className='action-buttons'>
                    <Link to="/dashboard/ViewDetails">
                     <button onClick={() => handleProductAction(product.id, 'details')} className="details">
                      View Details
                    </button>
                    </Link>
 
                  </div>
               
                </td>
              </tr>
            ))}
          </tbody>
        </table>
               <div className="table-footer">
                <div className="showing-info">
                  Showing 17 of 100
                </div>
                <div className="pagination">
                  <button className="active">1</button>
                  <button>2</button>
                  <button>3</button>
                  <button>4</button>
                  <button>5</button>
                  <button>Next</button>
                </div>
              </div>
      </div>
    </div>
  );
};

export default SalesMovement; 